import { fetchTelegramNonce, loginTelegram } from './auth-api';

export function isTelegramMiniApp() {
  return Boolean(window.Telegram?.WebApp?.initData);
}

export function initTelegramWebApp() {
  const tg = window.Telegram?.WebApp;
  if (!tg) return null;
  tg.ready();
  tg.expand();
  return tg;
}

export async function tryTelegramLogin() {
  const tg = initTelegramWebApp();
  if (!tg?.initData) return null;

  const nonceRes = await fetchTelegramNonce();
  const login = await loginTelegram({
    initData: tg.initData,
    nonce: nonceRes.nonce,
    launchId: nonceRes.launchId,
  });

  return login;
}
